import { Skeleton } from '@/components/ui'
import { PortfolioHeading } from './PortfolioHeading'

const MONEY_LINES = [
  'deposits',
  'withdrawals',
  'transfers-in',
  'transfers-out',
  'net-money',
  'dividends',
]
const ACCOUNT_ROWS = ['first', 'second', 'third']

const MoneyLine = () => (
  <div className="flex items-center justify-between gap-4">
    <Skeleton className="h-4 w-28" />
    <Skeleton className="h-4 w-20" />
  </div>
)

const AccountRowSkeleton = () => (
  <div className="flex items-center gap-6 border-t py-4 first:border-t-0">
    <Skeleton className="h-4 flex-1" />
    <Skeleton className="h-4 w-24" />
    <Skeleton className="h-4 w-28" />
    <Skeleton className="h-4 w-24" />
    <Skeleton className="h-5 w-20 rounded-full" />
  </div>
)

const HeroSkeleton = () => (
  <section className="@container rounded-lg border bg-white p-6 text-sm text-blue-7">
    <div className="flex items-center justify-between gap-4">
      <h3 className="text-base font-semibold">All accounts</h3>
      <Skeleton className="h-5 w-20 rounded-full" />
    </div>
    <div className="mt-6 grid grid-cols-1 gap-x-16 gap-y-8 @4xl:grid-cols-[minmax(0,1fr)_420px]">
      <div className="flex flex-col gap-3">
        <Skeleton className="h-3 w-48" />
        <Skeleton className="h-[38px] w-64" />
        <div className="mt-2 flex gap-12">
          <Skeleton className="h-9 w-32" />
          <Skeleton className="h-9 w-32" />
        </div>
        <Skeleton className="mt-4 h-[150px] w-full" />
      </div>
      <div className="flex flex-col gap-4">
        <Skeleton className="h-3 w-56" />
        {MONEY_LINES.map((line) => (
          <MoneyLine key={line} />
        ))}
      </div>
    </div>
  </section>
)

const AccountsSkeleton = () => (
  <section className="rounded-lg border bg-white px-6 pt-6 pb-3 text-sm text-blue-7">
    <h3 className="text-base font-semibold">Accounts</h3>
    <div className="mt-5">
      {ACCOUNT_ROWS.map((row) => (
        <AccountRowSkeleton key={row} />
      ))}
    </div>
  </section>
)

// The screen's own shape while the statements and the ledger load, so nothing jumps when they land.
export const PortfolioSkeleton = () => (
  <div className="flex min-h-0 flex-1 flex-col gap-4" aria-busy="true">
    <PortfolioHeading />
    <HeroSkeleton />
    <AccountsSkeleton />
    <div className="mt-5 flex min-h-10 items-center gap-3">
      <span className="text-sm text-ink-subtle">Showing</span>
      <Skeleton className="h-10 w-[340px]" />
    </div>
  </div>
)
